import 'reflect-metadata';
import hex from 'crypto-js/enc-hex.js';
import md5 from 'crypto-js/md5.js';
import { BaseEntityDescriptor, } from '../core/BaseEntityDescriptor.js';
import MessageDescriptor from '../message/MessageDescriptor.js';
import ServiceError from './ServiceError.js';
import { errorStore } from './stores.js';
const SERVICE_ERROR_METADATA_KEY = Symbol('serviceError:data');
class ServiceErrorDescriptor extends BaseEntityDescriptor {
    OwnerClass;
    code;
    status;
    message;
    responseClass;
    constructor(target, data) {
        super(target.name);
        this.OwnerClass = target;
        this.code = md5(target.name).toString(hex).substring(0, 6).toUpperCase();
        if (errorStore[this.code]) {
            throw new Error(`Conflicting error definition for ${target.name}`);
        }
        errorStore[this.code] = target;
        this.status = data.status;
        this.message = data.message;
        this.responseClass = data.responseClass;
    }
    static register(target, data) {
        Reflect.defineMetadata(SERVICE_ERROR_METADATA_KEY, new ServiceErrorDescriptor(target, data), target.prototype);
    }
    static load(target) {
        const targetProto = target instanceof ServiceError ? target : target.prototype;
        const descriptor = Reflect.getMetadata(SERVICE_ERROR_METADATA_KEY, targetProto);
        return descriptor;
    }
    getExample(transport) {
        const errorExample = {
            code: this.code,
            message: this.message,
        };
        if (this.responseClass) {
            errorExample.response = MessageDescriptor.load(this.responseClass).getExample(transport);
        }
        return {
            errors: [errorExample],
        };
    }
    toSchema(transport) {
        const references = [];
        const schema = {
            type: 'object',
            description: this.message,
            properties: {
                errors: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            code: {
                                type: 'string',
                                enum: [this.code],
                                description: 'Error unique identifier',
                            },
                            message: {
                                type: 'string',
                                enum: [this.message],
                                description: 'The message of this error class',
                            },
                            details: {
                                type: 'string',
                                description: 'The details of this specific error event',
                            },
                            errorCode: {
                                type: 'string',
                                description: 'The error code of this specific error event',
                            },
                        },
                        required: ['code', 'message'],
                    },
                },
            },
            example: {
                errors: [
                    {
                        code: this.code,
                        message: this.message,
                    },
                ],
            },
        };
        if (this.responseClass) {
            const descriptor = MessageDescriptor.load(this.responseClass);
            schema.properties.errors.items.properties.response = {
                $ref: `#/components/schemas/${this.responseClass.name}`,
            };
            references.push(descriptor);
            schema.example.errors[0].response = descriptor.getExample(transport);
        }
        return {
            schema,
            references,
        };
    }
    toProto() {
        const proto = {
            proto: {
                comments: [],
                definition: [],
            },
            references: [],
        };
        const fields = [
            '  string code = 2;',
            '  string message = 3;',
            '  string details = 4;',
            '  string errorCode = 6;',
        ];
        if (this.responseClass) {
            fields.push(`  ${this.responseClass.name} response = 5;`);
            proto.references.push(MessageDescriptor.load(this.responseClass));
        }
        proto.proto.definition = ['', `message ${this.name} {`, ...fields, '}'];
        return proto;
    }
}
export default ServiceErrorDescriptor;
//# sourceMappingURL=ServiceErrorDescriptor.js.map